import Logo from "./Logo"
import { scrollToId } from "./Nav"
import { EMAIL, LINKEDIN, WHATSAPP_DISPLAY, whatsappLink } from "./data"

const nav = [
  { id: "servicos", label: "Serviços" },
  { id: "processo", label: "Como trabalhamos" },
  { id: "projetos", label: "Projetos" },
  { id: "depoimentos", label: "Depoimentos" },
  { id: "contato", label: "Contato" },
]

const Footer = () => {
  const go = (id) => (e) => {
    e.preventDefault()
    scrollToId(id)
  }

  return (
    <footer className="k-footer">
      <div className="k-container">
        <div className="k-footer__top">
          <div className="k-footer__brand">
            <Logo className="k-footer__logo" />
            <p>Convertendo sonhos e ideias em realidade com desenvolvimento moderno e escalável.</p>
          </div>

          <div className="k-footer__col">
            <h4>Navegação</h4>
            <ul>
              {nav.map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`} onClick={go(n.id)}>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="k-footer__col">
            <h4>Contato</h4>
            <ul>
              <li>
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
                  WhatsApp {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
              </li>
              <li>
                <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="k-footer__word" aria-hidden>
          KJR<span>dev</span>
        </div>

        <div className="k-footer__bottom">
          <span>© {new Date().getFullYear()} KJR Desenvolvimento. Todos os direitos reservados.</span>
          <a href="#top" onClick={go("top")}>
            Voltar ao topo ↑
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
